module.exports = __webpack_public_path__ + "img/icon_tb_arrow.b882a08b.svg";